const communities = [
  { name: "Black Eagle", zip: "59414", note: "2 miles northeast" },
  { name: "Malmstrom AFB", zip: "59402", note: "3 miles east" },
  { name: "Vaughn", zip: "59487", note: "10 miles west" },
  { name: "Belt", zip: "59412", note: "25 miles southeast" },
  { name: "Fort Benton", zip: "59442", note: "38 miles northeast" },
  { name: "Choteau", zip: "59422", note: "50 miles northwest" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              Serving Great Falls and All of Cascade County
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Fast Passport Center handles passport services for residents across greater Great Falls — including Downtown, the Westside, Malmstrom AFB, and surrounding Cascade County communities. The nearest Regional Passport Agency is in Seattle, over 490 miles west via I-90. We eliminate that trip entirely.
            </p>
            <div className="bg-[#F7F8FA] rounded-lg p-5 mb-6">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#F6C344] text-lg"></i>
                </div>
                <div>
                  <p className="font-semibold text-[#1A365D] text-sm mb-1">Nearest Passport Agency</p>
                  <p className="text-gray-500 text-sm">Seattle Regional Passport Agency — 915 2nd Ave Suite 500, Seattle, WA 98101 — 490+ miles west via I-90. Fast Passport Center eliminates this trip for Great Falls residents, including Malmstrom AFB personnel.</p>
                </div>
              </div>
            </div>
            <div className="bg-[#F7F8FA] rounded-lg p-5">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-flight-takeoff-line text-[#F6C344] text-lg"></i>
                </div>
                <div>
                  <p className="font-semibold text-[#1A365D] text-sm mb-1">Great Falls International Airport (GTF)</p>
                  <p className="text-gray-500 text-sm">Serving Great Falls with flights to Denver, Seattle, and Salt Lake City. GTF connects central Montana travelers to international hubs requiring a valid passport.</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-gray-400 mb-4">Communities We Serve</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {communities.map((c, i) => (
                <div key={i} className="flex items-center gap-3 bg-[#F7F8FA] rounded-lg p-4">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                    <i className="ri-map-pin-line text-[#1A365D] text-sm"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A365D] text-sm">{c.name}</p>
                    <p className="text-gray-400 text-xs">ZIP {c.zip} &middot; {c.note}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 p-4 bg-[#EEF2F8] rounded-lg flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-[#1A365D] text-lg"></i>
              </div>
              <p className="text-[#1A365D] text-sm leading-relaxed">
                <strong>Don&apos;t see your city?</strong> Fast Passport Center serves all Montana zip codes — mail-in service means no geographic restriction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}